import React from "react";
import { AppBarDefault } from "./AppBarDefault";

interface HeaderProp {
  lang?: string;
  currency?: string;
}

const Header = ({ lang, currency }: HeaderProp) => {

  return <AppBarDefault currency={currency} locale={lang} />;
};

export default Header;
